module.exports = __webpack_public_path__ + "338f4ee5aa4a746bb5acfb85442eff47.pdf";